// extracted by mini-css-extract-plugin
var _1 = "SummaryStyles-module__itemLabel___ppGma";
var _2 = "SummaryStyles-module__itemValue___owGJj";
var _3 = "SummaryStyles-module__sectionLabel___Q94PP";
var _4 = "SummaryStyles-module__usdtToFiatAgreement___Yi9oy";
export { _1 as "itemLabel", _2 as "itemValue", _3 as "sectionLabel", _4 as "usdtToFiatAgreement" }
